// @flow
// This component will be deprecated in Q32021 in favor of our stripethirdparty Youtube player library
// Please do not use it in any new docs

import * as React from 'react';
import classnames from 'classnames';
import Box from 'sail/Box';
import './YouTube.scss';

type YouTubeProps = {|
  src: string,
  width?: number,
  height?: number,
  controls: boolean,
  id?: string,
  className?: string,
  children?: React.Node,
|};

export const YouTube = ({
  src,
  width = 640,
  height = 360,
  controls,
  id,
  className = '',
  children,
}: YouTubeProps) => {
  const iFrameProps = {
    width,
    height,
  };

  const url = new URL(src);
  url.searchParams.append('controls', controls === false ? '0' : '1'); // default: 1 / true
  url.searchParams.append('rel', '0'); // only show related videos from our channel

  return (
    <Box
      id={id}
      className={classnames('YouTube', className)}
      padding={{top: 32, bottom: 12}}
    >
      <iframe
        {...iFrameProps}
        src={url.toString()}
        frameBorder="0"
        allowFullScreen
      />
      {children}
    </Box>
  );
};
